import script from "./title-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./title-card.vue?vue&type=script&setup=true&lang=ts"

import "./title-card.vue?vue&type=style&index=0&id=84ea9cc9&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84ea9cc9"]])

export default __exports__